export default __webpack_public_path__ + "static/media/B6.dde08475.gif";